import {useEffect, useState,useContext} from "react";
import {useHistory} from "react-router-dom";
import SearchIcon from "@material-ui/icons/Search";
import {makeStyles} from "@material-ui/core/styles";
import {AuthContext} from '../context/AuthContext'
import {GeneralesContext} from '../context/GeneralesContext'
import { Box, Button, Card, CardContent, Grid,
    IconButton, LinearProgress, Paper, Tooltip,
    Typography,} from "@material-ui/core";
import axios from "axios";
import { SvgLoader, SvgProxy } from "react-svgmt";

const useStyles = makeStyles((theme) => ({}));

const listSvg=[{Id:1,Color:"#5DE163"},{Id:2,Color:"#5DE163"},{Id:3,Color:"#5DE163"},{Id:4,Color:"#5DE163"},{Id:5,Color:"#5DE163"},
    {Id:6,Color:"#5DE163"},{Id:7,Color:"#5DE163"},{Id:8,Color:"#5DE163"},{Id:9,Color:"#FFC400"},{Id:10,Color:"#FFC400"},
    {Id:11,Color:"#FFC400"},{Id:12,Color:"#FFC400"},{Id:13,Color:"#FFC400"},{Id:14,Color:"#FFC400"},
    {Id:15,Color:"#FFC400"},{Id:16,Color:"#FFC400"},
]
const listSvg2=[{Id:1,Color:"#5DE163"},{Id:2,Color:"#5DE163"},{Id:3,Color:"#5DE163"},{Id:4,Color:"#5DE163"},{Id:5,Color:"#5DE163"},
    {Id:6,Color:"#5DE163"},{Id:7,Color:"#5DE163"},{Id:8,Color:"#5DE163"},{Id:9,Color:"#FFC400"},{Id:10,Color:"#FFC400"},
    {Id:11,Color:"#FFC400"},{Id:12,Color:"#FFC400"},{Id:13,Color:"#FFC400"},{Id:14,Color:"#FFC400"},
    {Id:15,Color:"#FFC400"},{Id:16,Color:"#FFC400"},{Id:17,Color:"#FFC400"},{Id:18,Color:"#FFC400"},
]
const MapaSvg = ({listDtoSvg, getListEncuesta}) => {
    const classes = useStyles();
    const idusu = localStorage.getItem("UsuId");
    const history = useHistory();
    const source = axios.CancelToken.source();
    const prb=["6","7","8","9","10","11","12","13","14","15","16","17","18","19","20","21","22","23","24","25","26","27","28","29",]
 
    const [listaLocal, setListaLocal] = useState([]);
    const [leyenda,setLeyenda]=useState("")
    useEffect(() => {
        //console.log(listDtoSvg);
        
        setListaLocal(listDtoSvg)
        
    }, [listDtoSvg]);
 
 
    const cambiaColor =(elemnto,colOriginal)=>{
        const filtro = listDtoSvg.filter((valor)=>valor.Svg !== elemnto.Svg)
        let nvo=[]
        if (elemnto.Col!=="#37f707" ) { 
            nvo={...elemnto,Col:"#37f707",colOriginal:colOriginal}
        }
        else{nvo={...elemnto,Col:elemnto.colOriginal, }}
        filtro.push(nvo)
        getListEncuesta(elemnto.Svg)
        console.log(elemnto);
        setLeyenda(elemnto.Nom)
        setListaLocal(filtro)
    }

    const cambiaColor2 =(elemnto)=>{
        const filtro = listaLocal.filter((valor)=>valor.Id !== elemnto.Id)
        let nvo=[]
        if (elemnto.Color!=="#5DE163" ) {
            nvo={Id:elemnto.Id,Color:"#5DE163"}
        }
        else{nvo={Id:elemnto.Id,Color:"#FFC400"}}
        filtro.push(nvo)
        console.log("engrane ",elemnto);
        
       
    }

    const principal = () => {
        return (
        <Grid container spacing={1}>
             
            {leyenda!==""  ?
                <Grid item xs={12}>
                    <Card>
                        <CardContent style={{padding:0.4+'rem'}} >
                            <Grid container spacing={1} alignItems={'center'} style={{marginLeft:".5rem"}}>
                            {leyenda}
                            </Grid>
                        </CardContent>
                    </Card>
                </Grid>
            :null }
            <Grid item xs={8}>
                <SvgLoader //path={"https://raw.githubusercontent.com/flekschas/simple-world-map/master/world-map.svg"}  
                    path={"mapas_bolivia.svg"}
                    width="400" height="auto">
                    {/*pone en gris todos los municipios por default*/}
                    <SvgProxy selector="ellipse" fill="#e6e6e6" />
                   {/* prb.map(code => (
                    <SvgProxy
                        key={code}
                        selector={"#svg_" + code}
                        fill="#e6e6e6"
                        style={"fill:red"}
                        onmousedown={ ( )=>{console.log(`Hello ${code}`)}}
                    />
                    ))  */}
                    {listaLocal.length!==0 ?
                        listaLocal.map(elemento => (
                            <SvgProxy
                                key={`#${elemento.Svg}`}
                                selector={`#${elemento.Svg},#${elemento.Svg} path `}
                                //selector={"#rodillo" + elemento.Id}
                                //onmousedown={`console.log("Hello ${elemento.Id}")`}
                                //onmousedown={`${ imprime(elemento.Id)}`}
                                onmousedown={ ()=>{cambiaColor(elemento,elemento.Col)}}
                                style={`fill:${elemento.Col}`}
                                
                            />))
                    :null}
                    {/* listSvg2.length!==0 ?
                        listSvg2.map(elemento => (
                            <SvgProxy
                                key={elemento.Id}
                                selector={"#engrane" + elemento.Id + ",#engrane" + elemento.Id + " path"}
                                //selector={"#rodillo" + elemento.Id}
                                //onmousedown={`console.log("Hello ${elemento.Id}")`}
                                //onmousedown={`${ imprime(elemento.Id)}`}
                                onmousedown={ ()=>{cambiaColor2(elemento)}}
                                style={`fill:${elemento.Color}`}
                                
                            />))
                    :null */}
                </SvgLoader>
            </Grid>
    
        </Grid>
        );
    };

    return <div>{principal()}</div>;
};

export default MapaSvg;
